/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DisconnectBillFlowRequest} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/DisconnectBillFlow.pb'
import {DisconnectBillFlowResponse} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/DisconnectBillFlow.pb'


export const disconnectBill = (request:DisconnectBillFlowRequest, options?: CashRequestOptions) => post<DisconnectBillFlowRequest, DisconnectBillFlowResponse>("/cash-app/bills/v1.0/app/disconnect-bill-flow", request, {...options, rejectOnError: true })